module.exports = __webpack_public_path__ + "img/Linkedin.204fa4e8.svg";